import React from "react";

import { IconName } from "../types";
import Icon from "./Icon";

const FooterBreadcrumbsItem = (props: {
  icon: IconName;
  title: string;
  active: boolean;
  visited: boolean;
}) => {
  return (
    <div
      className={`footer-breadcrumbs-item ${props.active ? "active" : ""} ${
        props.visited ? "visited" : ""
      }`}
    >
      <Icon name={props.icon} />
      <span className={"footer-breadcrumbs-title"}>{props.title}</span>
    </div>
  );
};

export default FooterBreadcrumbsItem;
